import clsx from 'clsx'
import React, { useCallback } from 'react'
import { useComparator } from '../../../hooks/useComparator'
import { useIsAllowedToFullUse } from '../../../hooks/useIsAllowedToFullUse'
import { useTranslate } from '../../contexts/TranslationContext'
import SvgCross from '../../svg/icons/Cross'
import SvgScales from '../../svg/icons/Scales'
import { Button } from './Button'
import style from './CompareButton.module.sass'

type CompareButtonProps = {
	id: string
	isLeftAligned?: boolean
	openModal?: () => void
}

export const CompareButton = React.memo(function CompareButton(props: CompareButtonProps) {
	const { addProduct, productsInComparator, removeById } = useComparator()
	const translate = useTranslate()
	const placedInComparator = productsInComparator.includes(props.id)

	const isAllowedToFullUse = useIsAllowedToFullUse()

	const onClick = useCallback(() => {
		if (isAllowedToFullUse) {
			return placedInComparator ? removeById(props.id) : addProduct(props.id)
		} else if (props.openModal) {
			props.openModal()
			return
		}
	}, [addProduct, isAllowedToFullUse, placedInComparator, props, removeById])

	return (
		<div className={clsx(style.buttonCompareWrapper, props.isLeftAligned && style.buttonCompareWrapperIsLeftAligned)}>
			<Button
				type={{ variant: 'naked', small: true }}
				icon={{ large: !placedInComparator, extraSmall: placedInComparator }}
				label={
					placedInComparator ? translate('compareButton.button.remove') : translate('compareButton.button.compare')
				}
				iconBefore={placedInComparator ? <SvgCross /> : <SvgScales />}
				onClick={onClick}
			/>
		</div>
	)
})
